import { CumulativeRainfall } from '@/model/CumulativeRainFall'
import { EventEmitter } from '@/model/EventEmitter'
import { BaseService } from '../BaseService'
import { ICumulativeRainfallService } from './ICumulativeRainfallService'
import { ServiceLocator } from '../ServiceLocator'
import { ISettingService } from '../setting/ISettingService'

export class CumulativeRainfallService extends BaseService implements ICumulativeRainfallService {
  readonly cumulativeRainfallSelectionChanged: EventEmitter<CumulativeRainfall | undefined> = new EventEmitter<
    CumulativeRainfall | undefined
  >()

  private cumulativesRainfalls = new Map<CumulativeRainfall['cumulativeTimeMinutes'], CumulativeRainfall>()

  private settingsService!: ISettingService

  constructor(serviceLocator: ServiceLocator) {
    super(serviceLocator)
    this.settingsService = serviceLocator.get<ISettingService>('setting')
    this.init()
  }

  private async init(): Promise<void> {
    const settings = await this.settingsService.getSettings()
    this.setCumulativeRainfall(settings.getCumulativeRainfalls())
  }

  private setCumulativeRainfall(cumulativeRainfall: CumulativeRainfall[]): void {
    this.cumulativesRainfalls = new Map(cumulativeRainfall.map((cr) => [cr.cumulativeTimeMinutes, cr]))
  }

  getCumulativeRainfall(): Map<CumulativeRainfall['cumulativeTimeMinutes'], CumulativeRainfall> {
    return this.cumulativesRainfalls
  }

  selectCumulativeRainfall(rainfall: CumulativeRainfall | undefined): void {
    this.cumulativeRainfallSelectionChanged.notify(rainfall)
  }

  selectCumulativeRainfallByTime(time: number | undefined): void {
    if (time === undefined) {
      this.cumulativeRainfallSelectionChanged.notify(undefined)
    } else {
      const selected = this.cumulativesRainfalls.get(time)
      this.cumulativeRainfallSelectionChanged.notify(selected)
    }
  }
}
